import React, { useEffect, useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

import "../../css/createSourceModal.css";
import {
    getSalesforceAuthUrl,
    salseForceConnectAut,
} from "../../helpers/Sources/salesForce/salesForce";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const SALESFORCE_LOGO = "/assets/images/typeImages/sales.png";

const SalesForceSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [salesInput, setSalesInput] = useState({
        salesName: "",
        crmHost: "",
    });
    const [connectData, setConnectData] = useState(null);
    const [salesSourceID, setSalesSourceID] = useState("");
    const [salesButtonDisabled, setButtonDisabled] = useState(true);
    const [btnCheck, setBtnCheck] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        salesName: "",
        crmHost: "",
    });
    const language = useSelector((state) => state.languagesState.languages);

    const connectLabel =
        language?.buttons?.connect_with_salesforce ?? "Connect with Salesforce";

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSalesInput({ ...salesInput, [name]: value });
        setErrorMessages((prevErrors) => ({
            ...prevErrors,
            [name]: value.trim() === "" ? "Cannot be blank!" : "",
        }));
    };
    const saveCrmMapping = (response) => {
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            props?.handleClose(salesSourceID);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getTracker) {
                props.addToTracker(salesSourceID);
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            setSalesSourceID("");
            setBtnCheck(false);
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    const sendDataSales = async (data) => {
        setIsButtonLoading(true);
        let newData = {
            code: data?.code,
            state: data?.state,
        };
        let id = salesSourceID;
        let response = await salseForceConnectAut(newData, id);
        if (response?.status) {
            setConnectData(response?.data?.field_data?.fields);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
        setIsButtonLoading(false);
    };

    useEffect(() => {
        if (salesInput) {
            if (
                salesInput?.salesName === "" ||
                salesInput?.salesName === null ||
                salesInput?.crmHost === "" ||
                salesInput?.crmHost === null
            ) {
                setButtonDisabled(true);
            } else {
                setButtonDisabled(false);
            }
        }
    }, [salesInput]);

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {connectData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={salesSourceID}
                            sourceType={"salesforce"}
                            mappingSuccess={saveCrmMapping}
                            isModal={props?.isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        ></CrmSourceMappingArea>
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages?.salesName === null}
                        >
                            <TextField
                                name="salesName"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.name ?? "Name"
                                }
                                value={salesInput?.salesName}
                                disabled={btnCheck === false}
                                error={errorMessages?.salesName === null}
                            />
                            {errorMessages?.salesName && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.salesName}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages?.crmHost === null}
                        >
                            <TextField
                                name="crmHost"
                                label={
                                    language?.source_modal?.crm_host ??
                                    "CRM Host"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.crm_host ??
                                    "CRM Host"
                                }
                                value={salesInput?.crmHost}
                                disabled={btnCheck === false}
                                error={errorMessages?.crmHost === null}
                            />
                            {errorMessages?.crmHost && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crmHost}
                                </div>
                            )}
                        </FormControl>

                        <LoginButton
                            code="salesforce"
                            getAuthUrl={getSalesforceAuthUrl}
                            getAuthUrlData={{
                                name: salesInput?.salesName,
                                usage_types: [4],
                                crm_host: salesInput?.crmHost,
                            }}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.url;
                            }}
                            onAuthUrlResponse={(response) =>
                                setSalesSourceID(response?.data?.source?.id)
                            }
                            onAuthUrlError={() => setIsButtonLoading(false)}
                            paramNames={["code", "state"]}
                            onSuccess={sendDataSales}
                            dataTransform={(params) => ({
                                code: params.code,
                                state: params.state,
                            })}
                            logoSrc={SALESFORCE_LOGO}
                            buttonText={connectLabel}
                            disabled={salesButtonDisabled}
                            isLoadingExternal={isButtonLoading}
                        />
                    </>
                )}
            </Form.Group>
        </div>
    );
};

export default SalesForceSource;
